// Persistência simples (localStorage) para notificações de atividade de tarefas
// Objetivo: manter "unread" até o usuário clicar/abrir, e compartilhar estado entre header e página /tasks

const keyForUser = (userId) => `taskActivity:${userId}`;

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const loadTaskActivity = (userId) => {
  if (!userId) return [];
  const raw = window.localStorage.getItem(keyForUser(userId));
  const parsed = raw ? safeParse(raw) : null;
  return Array.isArray(parsed) ? parsed : [];
};

export const saveTaskActivity = (userId, items) => {
  if (!userId) return;
  window.localStorage.setItem(keyForUser(userId), JSON.stringify(items || []));
  // evento interno (não depende de abas)
  window.dispatchEvent(new Event("task-activity-updated"));
};

export const addTaskActivity = (userId, item) => {
  const items = loadTaskActivity(userId);
  // evitar duplicatas por id (quando backend reenviar)
  if (item?.id && items.some((i) => i.id === item.id)) return items;
  const next = [item, ...items].slice(0, 50); // cap simples
  saveTaskActivity(userId, next);
  return next;
};

export const removeTaskActivity = (userId, notificationId) => {
  const items = loadTaskActivity(userId);
  const next = items.filter((i) => i.id !== notificationId);
  saveTaskActivity(userId, next);
  return next;
};

export const markTaskActivityReadByTaskId = (userId, taskId) => {
  const items = loadTaskActivity(userId);
  const next = items.filter((i) => Number(i.taskId) !== Number(taskId));
  saveTaskActivity(userId, next);
  return next;
};

export const getUnreadTaskIds = (userId) => {
  const items = loadTaskActivity(userId);
  return new Set(items.map((i) => Number(i.taskId)).filter(Boolean));
};


